import React from 'react';
import { BaseEdge, getSmoothStepPath, MarkerType } from '@xyflow/react';
import './ArchFlow.scss';

export const BiDirectionalEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  data = {},
  markerEnd,
  markerStart
}) => {
  let edgePath = data.customPath;
  if (!edgePath) {
    [edgePath] = getSmoothStepPath({
      sourceX,
      sourceY,
      sourcePosition,
      targetX,
      targetY,
      targetPosition,
      borderRadius: 0 
    });
  }

  // To simulate bi-directional flow, we render two paths!
  // One for the forward animation, one for the backward animation.
  // We use CSS classes defined in ArchFlow.scss to animate them in opposite directions.
  return (
    <>
      <BaseEdge
        id={`${id}-base`}
        path={edgePath}
        style={{ ...style, strokeDasharray: 'none', strokeWidth: 1 }}
        markerEnd={markerEnd}
        markerStart={markerStart}
      />
      {/* Forward flowing dots */}
      <path
        d={edgePath}
        fill="none"
        stroke={style.stroke || '#0b4e96'}
        strokeWidth={style.strokeWidth || 2}
        className="react-flow__edge-path bi-flow-forward"
      />
      {/* Backward flowing dots */}
      <path
        d={edgePath}
        fill="none"
        stroke={style.stroke || '#0b4e96'}
        strokeWidth={style.strokeWidth || 2}
        className="react-flow__edge-path bi-flow-backward"
      />
    </>
  );
};

export const edgeTypes = {
  bidi: BiDirectionalEdge,
};
